import { render, staticRenderFns } from "./target.vue?vue&type=template&id=fa4dba84&"
import script from "./target.vue?vue&type=script&lang=js&"
export * from "./target.vue?vue&type=script&lang=js&"
import style0 from "./target.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports